<template>
    <img src="./img/img.png" style="width: 100%" />
</template>
<script>
    export default {
        name: 'BookmarkImg',
    }
</script>
